import Vue from 'vue'
import App from './App.vue'
import router from './router'
import https from './assets/api/http.js'
import utils from './utils/utils'
import './assets/css/style.css'
import './assets/css/common.css'

Vue.config.productionTip = false
Vue.prototype.$api = https
Vue.prototype.$utils = utils

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")
